import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
export var initI18n = function initI18n(i18nInstance) {
  if (typeof window !== 'undefined') {
    try {
      i18nInstance.init();
      var ld = new LanguageDetector(i18nInstance.services, {});

      if (ld.detect()) {
        i18nInstance.use(LanguageDetector);
      }
    } catch (e) {
      console.warn('Failed to load LanguageDetector');
    }
  }

  return i18nInstance.use(initReactI18next).init({
    fallbackLng: 'en'
  });
};
initI18n(i18next);
export default i18next;